export default __webpack_public_path__ + "static/media/avishy_sidlesky.57bc4423.jpeg";